import GridItemRoot, { Props, Ref } from './GridItem'
import { forwardRef } from 'react'

function GridItem(props: Props, ref?: Ref) {
  return <GridItemRoot {...props} ref={ref} />
}

export default forwardRef(GridItem)
